import type { VersionInfo } from '@/types/version';

/**
 * 最新バージョン情報を取得
 * キャッシュを無効化して常に最新のversion.jsonを取得する
 */
export const fetchLatestVersion = async (): Promise<VersionInfo | null> => {
  try {
    const response = await fetch('/version.json', {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });

    if (!response.ok) {
      return null;
    }

    const versionInfo: VersionInfo = await response.json();
    return versionInfo;
  } catch (error) {
    console.error('Failed to fetch version info:', error);
    return null;
  }
};

/**
 * セマンティックバージョンを比較
 * @param a 比較元バージョン
 * @param b 比較先バージョン
 * @returns a > b: 1, a < b: -1, a === b: 0
 */
export const compareVersions = (a: string, b: string): number => {
  const partsA = a.split('.').map(Number);
  const partsB = b.split('.').map(Number);

  const maxLength = Math.max(partsA.length, partsB.length);

  for (let i = 0; i < maxLength; i++) {
    const numA = partsA[i] ?? 0;
    const numB = partsB[i] ?? 0;

    if (numA > numB) return 1;
    if (numA < numB) return -1;
  }

  return 0;
};

/**
 * キャッシュをクリアしてページをリロード
 */
export const clearCacheAndReload = async (): Promise<void> => {
  try {
    // Cache APIが利用可能な場合、全てのキャッシュをクリア
    if (typeof caches !== 'undefined') {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
  } catch (error) {
    console.error('Failed to clear caches:', error);
  }

  // ページをリロード
  window.location.reload();
};
